// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import AccountMessages from "@insite/content-library/Widgets/MyAccount/AccountMessages";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import XngSticky from "@tps/App/Components/XngSticky";
import * as React from "react";

interface OwnProps extends WidgetProps {}

type Props = OwnProps;

export interface MyAccountViewStyles {
    quickLinksGridItem?: GridItemProps;
    mainSectionGridItem?: GridItemProps;
    mainSectionGridContainer?: GridContainerProps;
    accountMessagesGridItem?: GridItemProps;
    dashboardWidgetsGridItem?: GridItemProps;
    // XNG-Changes
    pageTitleGridItem?: GridItemProps;
    makeDashboardMyHomePageGridItem?: GridItemProps;
    dashboardSummaryGridItem?: GridItemProps;
}

export const myAccountViewStyles: MyAccountViewStyles = {
    quickLinksGridItem: { width: [12, 12, 12, 2, 2] },
    mainSectionGridItem: { width: [12, 12, 12, 10, 10] },
    accountMessagesGridItem: { width: 12 },
    dashboardWidgetsGridItem: { width: 12 },
};

const styles = myAccountViewStyles;

class MyAccountView extends React.PureComponent<Props> {
    render() {
        // XNG-Changes: Update structure
        return (
            <GridContainer>
                <GridItem width={12}>
                    <GridContainer gap={5}>
                        <GridItem {...styles.pageTitleGridItem}>
                            <Zone contentId={this.props.id} zoneName="PageTitle" />
                        </GridItem>
                        <GridItem {...styles.makeDashboardMyHomePageGridItem}>
                            <Zone contentId={this.props.id} zoneName="MakeDashboardMyHomePage" />
                        </GridItem>
                    </GridContainer>
                </GridItem>
                <GridItem {...styles.quickLinksGridItem}>
                    <XngSticky stopBreakpoint="md">
                        <Zone contentId={this.props.id} zoneName="NavigationList" />
                    </XngSticky>
                </GridItem>
                <GridItem {...styles.mainSectionGridItem}>
                    <GridContainer>
                        <GridItem {...styles.accountMessagesGridItem}>
                            <AccountMessages />
                        </GridItem>
                        <GridItem {...styles.dashboardSummaryGridItem}>
                            <Zone contentId={this.props.id} zoneName="DashboardWidgets" />
                        </GridItem>
                    </GridContainer>
                </GridItem>
            </GridContainer>
        );
    }
}

const myAccountViewWidget: WidgetModule = {
    component: MyAccountView,
    definition: {
        allowedContexts: ["MyAccountPage"],
        group: "My Account",
    },
};

export default myAccountViewWidget;
